import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';

export default function WebinarRoom() {
  useLanguage();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">{translateInterfaceText("Sala do Webinário")}</h1>
        <p className="text-muted-foreground">{translateInterfaceText("Em desenvolvimento...")}</p>
      </div>
    </div>
  );
}
